<template>
    <div>
        <div style="height: 500px" ref="barChart"></div>
    </div>
</template>

<script>
// importing AMCharts
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
//default theme for AMcharts
am4core.useTheme(am4themes_animated);
export default {
    name: 'module-wise-bar-chart',
    data() {
        return {
            data: null
        }
    },
    methods: {
        getBarChatData() {
            axios.get("dashboard/semipiechart")
                .then((response) => {
                    this.data = response.data;
                    console.log(this.data)
                    this.moduleWiseBarChart();

                })
                .catch((error) => {
                    this.errored = true;
                })
                .finally(() => (this.loader = false));
        },
        moduleWiseBarChart() {
            var chart = am4core.create(this.$refs.barChart, am4charts.XYChart);
            chart.data = this.data;
            
            chart.padding(40, 40, 40, 40);

            var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.dataFields.category = "module";
            categoryAxis.renderer.minGridDistance = 60;
            categoryAxis.renderer.inversed = true;
            categoryAxis.renderer.grid.template.disabled = true;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.extraMax = 0.1;
            //valueAxis.rangeChangeEasing = am4core.ease.linear;
            //valueAxis.rangeChangeDuration = 1500;

            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.categoryX = "module";
            series.dataFields.valueY = "value";
            series.tooltipText = "{valueY.value}"
            series.columns.template.strokeOpacity = 0;
            series.columns.template.column.cornerRadiusTopRight = 10;
            series.columns.template.column.cornerRadiusTopLeft = 10;
            //series.interpolationDuration = 1500;
            //series.interpolationEasing = am4core.ease.linear;
            var labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.verticalCenter = "bottom";
            labelBullet.label.dy = -10;
            labelBullet.label.text = "{values.valueY.workingValue.formatNumber('#.')}";

            chart.zoomOutButton.disabled = true;

            // as by default columns of the same series are of the same color, we add adapter which takes colors from chart.colors color set
            series.columns.template.adapter.add("fill", function (fill, target) {
                return chart.colors.getIndex(target.dataItem.index);
            });

            // categoryAxis.sortBySeries = series;

        },
    },
    mounted() {
        this.getBarChatData();
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
}
</script>

<style lang="sass" scoped>

</style>
